"use strict"; // NOTE: These types are used by Wit.AI models
// https://wit.ai/youmustfight/upsolve-docket-parse-v4

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REOPEN_CASE = exports.OBJECT_DISMISS = exports.EXTEND_TIME = exports.INSTALLMENT = exports.HEARING_SHOW_CAUSE = exports.HEARING_MINUTES = exports.HEARING_LIFT_STAY = exports.HEARING_FEE_WAIVER = exports.HEARING_DISMISSAL = exports.CREDITORS_MEETING = exports.PHOTO_ID = exports.UPSOLVE_LETTER = exports.SSN = exports.PRO_SE_QUESTIONNAIRE = exports.PETITION = exports.PAY_STUBS = exports.MEANS_TEST = exports.INSTALLMENT_APPLICATION = exports.FEE_WAIVER_APPLICATION = exports.CREDITORS_MATRIX = exports.COURSE_TWO_CERTIFICATE = exports.COURSE_ONE_CERTIFICATE = void 0; // Documents

exports.COURSE_ONE_CERTIFICATE = "courseOneCertificate";
exports.COURSE_TWO_CERTIFICATE = "courseTwoCertificate";
exports.CREDITORS_MATRIX = "creditorsMatrix";
exports.FEE_WAIVER_APPLICATION = "feeWaiverApplication";
exports.INSTALLMENT_APPLICATION = "installmentApplication";
exports.MEANS_TEST = "meansTest";
exports.PAY_STUBS = "payStubs";
exports.PETITION = "petition";
exports.PRO_SE_QUESTIONNAIRE = "proSeQuestionnaire";
exports.SSN = "ssn";
exports.UPSOLVE_LETTER = "upsolveLetter";
exports.PHOTO_ID = "photoId"; // Meetings

exports.CREDITORS_MEETING = "creditorsMeeting";
exports.HEARING_DISMISSAL = "hearingDismissal";
exports.HEARING_FEE_WAIVER = "hearingFeeWaiver";
exports.HEARING_LIFT_STAY = "hearingLiftStay";
exports.HEARING_MINUTES = "hearingMinutes";
exports.HEARING_SHOW_CAUSE = "hearingShowCause"; // Payment

exports.INSTALLMENT = "installment"; // Motions

exports.EXTEND_TIME = "extendTime"; // export const DISMISS = 'dismiss';

exports.OBJECT_DISMISS = "objectDismiss";
exports.REOPEN_CASE = "reOpenCase";